import "../scss/front.scss";

(function ($) {
    $(document).ready(function () {
        console.log("ajax", siteConfig.ajaxUrl);

        var pagination = $(".pagination .member-pagination");
        console.log("pag", pagination);

        function triggerPagination(page) {
            var params = new URLSearchParams(window.location.search);
            let memberName = params.get("member_name");
            let nepasMembershipNo = params.get("nepas_membership_no");
            let province = params.get("province");
            let speciality = params.get("speciality");
            console.log("params.get('member_name');", params.get("member_name"));
            $.ajax({
                url: siteConfig.ajaxUrl,
                type: "post",
                data: {
                    action: "members_pagination",
                    page: page,
                    member_name: memberName,
                    nepas_membership_no: nepasMembershipNo,
                    province: province,
                    speciality: speciality,
                },
                success: function (response) {
                    console.log("page");
                    $(".member-container").html(response);
                },
            });
        }

        $(document).on("click", ".pagination .member-pagination", function (e) {
            e.preventDefault();
            console.log("clicked");
            var page = $(this).data("page");
            console.log("abc", page);
            triggerPagination(page);
        });
    });
})(jQuery);
